import React from 'react'
import { BlogBanner, BlogBannerContent, SpaceHero, TitleGeral, Post } from './style'

import Logo from '../../assets/logo.png'

export default function Blog() {
  return (
    <>
      <BlogBanner>
        <BlogBannerContent>
          <div>
            <a href="/">
              <img alt="Boticário" title="Boticário" src={Logo} className="logo" />
              O Boticário
            </a>
            <h2>Nuestro blog</h2>
            <p>
              Con tu llegada hasta acá queremos contarte un poco más de lo que somos, lo que es nuestra industria y lo que te enamorará a ti y tus clientes.
            </p>
          </div>
        </BlogBannerContent>
      </BlogBanner>

      <SpaceHero />

      <TitleGeral>
        ¡Nuestro contenido!
        <span>Nuevas entradas</span>
      </TitleGeral>

      <Post>
        <div className="post--content">
          <h2>
            ¿Por qué hoy todo el mundo habla de emprender?
          </h2>
          <p>
            ¿Tendencia o estilo de vida? En la actualidad es muy común escuchar la palabra emprender, sin embargo, muchos aún no tenemos claridad de lo que esto realmente significa, pues lo asociamos con la idea de lograr esa independencia y estabilidad económica que tanto soñamos conseguir en un negocio.
          </p>
          <a href="/por-que-hoy-todo-el-mundo-habla-de-emprender/">Seguir leyendo</a>
        </div>
        
        <div className="post--banner"></div>
      </Post>
    </>
  )
}